import testi1 from 'assets/images/testi1.png';
import testi2 from 'assets/images/testi2.png';
import testi3 from 'assets/images/testi3.png';

export const testimonies = [
  {
    id: 1,
    icon: testi1,
    name: 'John Doe',
    company: 'Company, Director',
    title: 'This has been such a helpful tool for us!',
    stars: 5,
    fullDesc:
      'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam.\n\nSed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiamSed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperia luptatem accusantium doloremque laudantium, totam rem aperiam',
  },
  {
    id: 2,
    icon: testi2,
    name: 'John Dont',
    company: 'Company, Director',
    title: 'Very cool!',
    stars: 5,
    fullDesc:
      'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam.\n\nSed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laurror sit voluptatem accusantium doloremque laudantium, totam rem aperia luptatem accusantium doloremque laudantium, totam rem aperiam',
  },
  {
    id: 3,
    icon: testi3,
    name: 'John Doesnt',
    company: 'Company, Director',
    title: 'Awesome tool guys!',
    stars: 4,
    fullDesc:
      'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium dole natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam.\n\nSed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiamSed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperia luptatem accusantium doloremque laudantium, totam rem aperiam',
  },
];

export const sample = '';
